<template>
  <b-table
    id="store-table"
    :per-page="0"
    :items="files"
    :fields="fields"
    show-empty
    striped
    responsive
    primary-key="temp_id"
  >
    <template v-slot:cell(duplicate_warning)="data">
      <div
        v-if="data.item.duplicate_warning && data.item.duplicate_warning.length"
        class="text-warning"
      >
        <i :id="data.item.temp_id" class="fa fa-warning cursor-pointer" />
        <b-tooltip :target="data.item.temp_id">
          Possible duplicate of
          <span
            v-for="(duplicate, index) in data.item.duplicate_warning"
            :key="`${data.item.temp_id}-${index}-${duplicate}`"
          >
            <a
              v-if="!isNaN(Number(duplicate))"
              :href="`#/template/${duplicate}`"
              target="_blank"
            >
              {{ duplicate
              }}<template v-if="index < data.item.duplicate_warning.length - 1"
                >,
              </template>
            </a>
            <template v-else
              >{{ duplicate
              }}<template v-if="index < data.item.duplicate_warning.length - 1"
                >,</template
              >
            </template>
          </span>
        </b-tooltip>
      </div>
    </template>
    <template v-slot:cell(file)="data">
      <img :src="getSVGPreview(data.item.file)" width="50px" height="50px" />
    </template>
    <template v-slot:cell(filename)="data">
      {{ data.item.filename }}
    </template>
    <template v-slot:cell(device_id)="data">
      <app-device-selector v-model="data.item.device_id" />
    </template>
    <template v-slot:cell(type_id)="data">
      <b-form-select v-model="data.item.type_id" class="form-control">
        <b-form-select-option
          v-for="templatetype in templatetypes"
          :key="`templatetype-${templatetype.id}-${data.index}`"
          :value="templatetype.id"
        >
          {{ templatetype.name }}
        </b-form-select-option>
      </b-form-select>
    </template>
    <template v-slot:cell(categories)="data">
      <div
        v-for="(value, key) in templateCategories"
        :key="`category-${key}-${data.index}`"
      >
        <label>
          <input type="checkbox" v-model="data.item[key]" /> {{ value }}
        </label>
      </div>
    </template>
    <template v-slot:cell(options)="data">
      <div
        v-for="(value, key) in templateOptions"
        :key="`options-${key}-${data.index}`"
      >
        <label>
          <input type="checkbox" v-model="data.item[key]" /> {{ value }}
        </label>
      </div>
    </template>
    <template v-slot:cell(action)="data">
      <div class="smart-import-table__actions">
        <b-button variant="primary" @click="saveFile(data.item, data.index)">
          <i class="fa fa-save" />
        </b-button>
        <b-button variant="danger" @click="removeFile(data.index)">
          <i class="fa fa-trash" />
        </b-button>
      </div>
    </template>
  </b-table>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import AppDeviceSelector from '@/components/devices/DeviceSelector';

export default {
  components: {
    AppDeviceSelector,
  },
  props: {
    value: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters('templatetypes', {
      templatetypes: 'getTemplateTypes',
    }),
    ...mapState('smartimport', {
      templateCategories: 'categories',
      templateOptions: 'options',
    }),
    getSVGPreview() {
      return (file) => {
        return URL.createObjectURL(file);
      };
    },
  },
  data() {
    return {
      files: this.value,
      fields: [
        { key: 'duplicate_warning', label: '' },
        { key: 'file', label: 'SVG' },
        { key: 'filename', label: 'Filename', sortable: true },
        { key: 'device_id', label: 'Device' },
        { key: 'type_id', label: 'Template Type' },
        { key: 'categories', label: 'Categories' },
        { key: 'options', label: 'Options' },
        { key: 'action', label: '' },
      ],
    };
  },
  methods: {
    removeFile(index) {
      this.files.splice(index, 1);
      this.$emit('input', this.files);
    },
    saveFile(item, index) {
      this.$emit('save-index', index);
    },
  },
  mounted() {
    this.$store.dispatch('smartimport/ensure');
  },
};
</script>
<style scoped>
.smart-import-table__actions {
  display: flex;
  gap: 10px;
  flex-direction: column;
}
</style>
